<div class="container" data-cy="insurance_claim_failure_page">
  <agreements-sign-verdict text="MY_BOOKING" subTitle="AGREEMENT_SIGN_ERROR_TITLE"
                           description="AGREEMENT_SIGN_ERROR_DESCRIPTION">
  </agreements-sign-verdict>
</div>
